import photo1 from './photo1.jpg'
import photo2 from './photo2.jpg'
import photo3 from './photo3.jpg'

export { photo1, photo2, photo3 }



// WEBPACK FOOTER //
// ./src/components/RoomsCatalog/images/index.js